/**
 * @author gyb(mocheer)
 * @email mocheer@foxmail.com  
 * @since 2017.6.12
 */
import PolylineTool from './PolylineTool'
//
let { Polyline } = L;
/**
 * 线绘制工具
 */
export default class DistanceTool extends PolylineTool {
  options = { feature: { color: 'red', weight: 2, showMeasurements: true, draggable: false } }
  /**
   * 
   */
  onMouseMove(e) {
    super.onMouseMove(e);
    this.marker.updateMeasurements();
  }
}


// WEBPACK FOOTER //
// ./src/plugins/tools/DistanceTool.js